import { FeatureFlagModel } from '../types/featureFlagModel';
import { FeatureFlagEndpoint } from '../properties/appProperties';
import { HttpMethod, sendAuthorizedRequest } from './authWrapper';

export async function getFeatureFlags(baseUrl: string,): Promise<FeatureFlagModel> {
  const requestUrl = baseUrl + FeatureFlagEndpoint;

  return sendAuthorizedRequest(HttpMethod.GET, requestUrl);
}
